export const actionTypes = {
  REQUEST_START: 'USER_INCOMES.PERCENT_DEPOSITS.REQUEST_START',
  REQUEST_SUCCESS: 'USER_INCOMES.PERCENT_DEPOSITS.REQUEST_SUCCESS',
  REQUEST_FAILURE: 'USER_INCOMES.PERCENT_DEPOSITS.REQUEST_FAILURE',
};

export function startRequest() {
  return {
    type: actionTypes.REQUEST_START,
  };
}

export function requestSuccess(data) {
  return {
    type: actionTypes.REQUEST_SUCCESS,
    payload: data,
  };
}

export function requestFailure(error) {
  return {
    type: actionTypes.REQUEST_FAILURE,
    payload: error,
  };
}
